// src/redux/clients/clientsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetAllClients } from '../vlp/services/ClientsMaintenanceService'; // <-- adjust path if needed

// Async thunk to load clients (uses your existing service)
export const fetchClients = createAsyncThunk(
  'clients/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetAllClients();
      // support two possible shapes: { statusCode, results } or direct array
      const clients = response && response.results ? response.results : response;
      return clients || [];
    } catch (err) {
      return rejectWithValue(err?.message || 'Failed to fetch clients');
    }
  }
);

const initialState = {
  data: [],          // array of ClientsSearchDto-like objects
  status: 'idle',    // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    // Optional local setters for manual updates
    setClients: (state, action) => {
      state.data = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearClients: (state) => {
      state.data = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClients.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { setClients, clearClients } = clientsSlice.actions;

// Selectors
export const selectClientsData = (state) => state.clients.data;
export const selectClientsStatus = (state) => state.clients.status;
export const selectClientsError = (state) => state.clients.error;

export default clientsSlice.reducer;